import React from "react";
import { Form, Button } from "react-bootstrap";
import Swal from 'sweetalert2';
import { pushDataLayer } from "../gtm";
import { calculateAge } from "../helpers/eligibility";


export default function Step2({ formData, setFormData, next, prev, onMayorEdad, onMenorEdad }) {

  // ─────────────────────────────────────────────
  // Acción al pulsar «Aceptar»
  const continuar = () => {
    const edad = calculateAge(formData.nacimiento);

    // Caso: fecha no ingresada
    if (isNaN(edad)) {
      Swal.fire({
        icon: "warning",
        title: "Fecha requerida",
        text: "Por favor, ingresá tu fecha de nacimiento.",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#000",
      });
      return;
    }

    // Caso 4: 30 años o más
    if (edad >= 30) {
      onMayorEdad?.();
      return;
    }

    // Caso 5: 17 años o menos
    if (edad <= 17) {
      onMenorEdad?.();
      return;
    }

    // Si la edad es válida (18-29), dispara evento y avanza
    pushDataLayer('paso6_liceoutu');
    next();
  };

  // ─────────────────────────────────────────────
  return (
    <div className="form-container">
      <h2 className="form-title">¿Fecha de nacimiento?</h2>
      <Form>
        <Form.Group className="mb-4">
          <Form.Label>Ingresá tu fecha</Form.Label>
          <Form.Control
            type="date"
            value={formData.nacimiento}
            onChange={(e) =>
              setFormData({ ...formData, nacimiento: e.target.value })
            }
          />
        </Form.Group>

        <div className="d-flex justify-content-between">
          <Button variant="secondary" onClick={prev}>
            Atrás
          </Button>
          <Button variant="primary" onClick={continuar}>
            Aceptar
          </Button>
        </div>
      </Form>
    </div>
  );
}
